import { Redirect } from "react-router-dom";

export default function RefereeHomeRedirect() {
  return <Redirect to="/referee/dashboard" />;
}
